import type { ExcJpmamV1NetOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const JPMAM_NET_ORDER_BASE_PATH = getResolvedPath('/clearing/vendor/jpm/net-order');

export const getJpmamNetOrderPath: EntityPathBuilder<ExcJpmamV1NetOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return JPMAM_NET_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.netOrderId) {
        return undefined;
      }

      return getResolvedPath(`${JPMAM_NET_ORDER_BASE_PATH}/$netOrderId`, context.keys);
    }
  }
};

export function getJpmamNetOrderDetailPath(netOrderId: string | undefined) {
  if (!netOrderId) {
    return undefined;
  }

  return getJpmamNetOrderPath({ kind: 'detail', keys: { netOrderId } });
}
